module.exports = function (breakpointsService, shopLocatorService, storePickerService, settingsService) {
    return {
        restrict: 'E',
        scope: {
            stockCode: '=',
            packSize: '=?',
            promotionType: '=?',
            onClose: '&?'
        },
        link(scope) {
            scope.breakpointsService = breakpointsService;

            scope.shopLocatorService = shopLocatorService;
            scope.searching = false;
            scope.isNavMapSelected = false;
            scope.storePicker = storePickerService;
            scope.firstRequest = true;
            scope.showOnlyIsAvailable = true;
            scope.checkCartAvailability = false;
            scope.showClearanceMessage = (scope.promotionType && scope.promotionType.toLowerCase() === 'clearance') ? true : false;

            function checkStores() {
                scope.searching = true;

                settingsService.getSettingValue('StoreLocator', 'CheckCartItemsAvailability').then(function (setting) {
                    scope.checkCartAvailability = setting;

                    shopLocatorService.checkNearbyStocks({
                        PostCode: scope.storePicker.store.AddressPostalCode,
                        StockCode: scope.stockCode,
                        IsAvailable: scope.showOnlyIsAvailable,
                        CheckCartAvailability: scope.checkCartAvailability
                    }).then(function (locations) {
                        scope.storesList = locations.splice(0, 5);
                        scope.searching = false;
                        scope.firstRequest = false;
                    });
                });
            }

            scope.getStoredLocation = function (state, suburb, postcode) {
                if (!state && !suburb && !postcode) {
                    return;
                }
                scope.searching = true;

                const dto = {
                    State: state,
                    Suburb: suburb,
                    PostCode: postcode,
                    Stockcode: scope.stockCode,
                    IsAvailable: scope.showOnlyIsAvailable,
                    CheckCartAvailability: scope.checkCartAvailability
                };

                shopLocatorService.checkNearbyStocks(dto)
                   .then(function (locations) {
                       scope.storesList = locations.splice(0, 5);
                       scope.searching = false;
                   });
            };

            scope.triggerOnSelect = function (store) {
                scope.storesList = [];
                scope.store = store;
                scope.getStoredLocation(store.State, store.SuburbName, store.PostCode);
            };

            scope.toggleView = (tab) => {
                scope.isNavMapSelected = tab === 'Map';
            };

            scope.$watch('storePicker.store', function (store) {
                if (store && !scope.firstRequest) {
                    scope.store = store;
                    scope.getStoredLocation(store.AddressState, store.AddressSuburb, store.AddressPostalCode);
                }
            });

            const toggleStoresWithAvailability = function () {
                if (!scope.firstRequest && scope.store) {
                    scope.getStoredLocation(scope.store.State, scope.store.SuburbName, scope.store.PostCode);
                } else {
                    checkStores();
                }
            };

            scope.$watch('showOnlyIsAvailable', function (val) {
                if (val !== undefined) {
                    toggleStoresWithAvailability(val);
                }
            });
        },
        template: require('./stock-nearby-locator-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shoplocator/stock-nearby-locator-directive.js
 **/